
import { Base64 } from 'js-base64'
import { mapActions } from 'vuex'


export default {
  methods: {
    ...mapActions('wxBind', ['getAppInfoX']),
    async toBind () {
      const { success, data } = await this.getAppInfoX()
      if (success) {
        const { uid } = data
        const redirectUri = `${window.location.origin}/user/wechat/binded`
        const appid = Base64.decode(uid)
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect`
        window.location.href = url
      }
    }
  }
}